module.exports = __webpack_public_path__ + "img/kong.f87bd46f.png";